export default "__VITE_ASSET__CHxzlc$7__"